import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from './../../shared/shared.module';
import { SearchCustomerRoutingModule } from './search-customer-routing.module';
import { SearchCustomerComponent } from './search-customer.component';
import { ChooseCustomerComponent } from './choose-customer/choose-customer.component';


@NgModule({
  declarations: [SearchCustomerComponent, ChooseCustomerComponent],
  imports: [
    CommonModule,
    SharedModule,
    SearchCustomerRoutingModule
  ]
})
export class SearchCustomerModule { }
